import { LocalStorageLatest } from './local-storage-latest';

// type safe stringify. Main purpose: enforce types.
export function stringifyLocalStorageLatest(input: LocalStorageLatest): string {
  return JSON.stringify(input);
}
